import { useState, useEffect, useRef } from "react";
import {
    Globe, ArrowRight, ChevronDown, ChevronUp, ChevronLeft, ChevronRight,
    MapPin, Send, AtSign, Phone, CheckCircle, TrendingUp, Target,
    Search, Monitor, Bot, Smartphone, Users, BarChart2, Clock,
    Shield, Zap, Award, Star, MessageCircle, ExternalLink, Code2,
    Layout, Database, GitBranch, Layers, Play
} from "lucide-react";

/* ── TELEGRAM ─────────────────────────────────── */
const TG_BOT_TOKEN = "8708133344:AAEdHvVWFjcg8Gv-MnDYUs9TI7EXfmJ1g3g";
const TG_CHAT_ID   = "-1003564455515";
async function sendToTelegram(name, phone, service, lang) {
    const text = `🔔 <b>Yangi murojaat / Новая заявка</b>\n\n👤 <b>Ism:</b> ${name}\n📞 <b>Tel:</b> ${phone}\n🛠 <b>Xizmat:</b> ${service||"—"}\n🌐 <b>Til:</b> ${lang==="uz"?"O'zbek":"Русский"}\n⏰ ${new Date().toLocaleString("uz-UZ")}`;
    try { await fetch(`https://api.telegram.org/bot${TG_BOT_TOKEN}/sendMessage`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({chat_id:TG_CHAT_ID,text,parse_mode:"HTML"})}); } catch(e){}
}

/* ── TRANSLATIONS ─────────────────────────────── */
const T = {
    uz: {
        nav:["Xizmatlar","IT Portfolio","Nima uchun biz","Narxlar","Aloqa"],
        navCta:"Bog'lanish", eyebrow:"Raqamli Marketing Agentligi",
        h1a:"Biznesingizni", h1b:"Raqamli", h1c:"Olamga Oling",
        heroDesc:"SMM, Targeting, SEO, Web sayt, Telegram bot va Mobil ilovalar — o'sish uchun barcha raqamli xizmatlar bir joyda.",
        heroCta1:"Bepul konsultatsiya", heroCta2:"Xizmatlar",
        s1:"Muvaffaqiyatli loyiha", s2:"Mijoz mamnuniyati", s3:"Yillik tajriba", s4:"Kontent yaratildi",
        svcLbl:"Xizmatlar", svcT:["Nima","Qilamiz?"],
        whyLbl:"Nima uchun biz?", whyT:["Aynan","Zamon","ni Tanlang"],
        processT:"Qanday ishlaymiz?", processLbl:"Bizning jarayon",
        indLbl:"Tajriba", indT:["Qaysi","Sohalarda","Ishlaymiz?"],
        itLbl:"IT Xizmatlar", itT:["Bizning","IT Portfolio"],
        itDesc:"Web saytlar, Telegram botlar va mobil ilovalar — texnik yechimlarimiz bilan tanishing.",
        priceLbl:"Narxlar", priceT:["SMM","Tariflari"],
        priceMonth:"har oy", pricePopular:"Mashhur", priceCta:"Individual paket?", priceCtaLink:"Bog'laning",
        faqLbl:"FAQ", faqT:["Ko'p So'raladigan","Savollar"],
        ctaLbl:"Aloqa", ctaT:["Biz Bilan","Bog'laning"],
        ctaDesc:"Biznesingizni rivojlantirish uchun birinchi qadamni tashlang. Bepul konsultatsiya va individual taklif beramiz.",
        ctaAddress:"Olmazor tumani, Beruniy ko'chasi 13A, Toshkent",
        footerDesc:"Professional raqamli marketing agentligi.",
        footerCol:["Xizmatlar","Kompaniya","Aloqa"],
        copyright:"Barcha huquqlar himoyalangan.",
        modalTitle:"Bepul konsultatsiya", modalDesc:"Ma'lumotlaringizni qoldiring — 15 daqiqa ichida javob beramiz.",
        modalName:"Ism Familiya", modalPhone:"Telefon raqam", modalService:"Xizmat turi (ixtiyoriy)",
        modalBtn:"Yuborish", modalSuccess:"Rahmat!", modalSuccessDesc:"15 daqiqa ichida bog'lanamiz.",
        modalReply:"15 daqiqa ichida javob", selectSvc:"Tanlang...",
        svcs:["SMM","Targeting","SEO","Web Sayt","Telegram Bot","Mobil Dastur","Kompleks paket"],
        whyItems:[
            ["Natijali stragetiya","Har bir loyihada o'lchov mezonlari belgilanadi."],
            ["Shaffof hisobotlar","Har hafta va oy real ko'rsatkichlar bilan hisobot yuboriladi."],
            ["Tez muloqot","Telegram orqali 15 daqiqa ichida javob. Hech qachon yo'qolmaymiz."],
            ["Bir joyda hamma narsa","SMM, targeting, web, bot — hamma xizmat bir agentlikdan."],
        ],
        processSteps:[
            ["Tahlil va strategiya","Biznesingiz, raqobat va auditoriyani chuqur o'rganamiz"],
            ["Maqsadlar va KPI","Aniq o'lchov mezonlari va muddat belgilaymiz"],
            ["Ijro va optimallashtirish","Jamoa ishga tushadi, natijalarni real vaqtda kuzatamiz"],
            ["Hisobot va o'sish","Tahlil qilib, keyingi oy strategiyasini yangilaymiz"],
        ],
        faqs:[
            ["Natija qachon ko'rinadi?","Targeting reklamalarda birinchi natijalar 3–7 kun ichida ko'rinadi. SMM organik o'sishi 1–2 oydan so'ng sezilarli bo'ladi. SEO natijalar 3–6 oy ichida kuzatiladi."],
            ["Minimal reklama byudjeti qancha?","Targeting uchun oyiga kamida $200 reklama byudjeti tavsiya etamiz. Bu maqsadli auditoriyangizga yetib borish uchun optimal miqdor."],
            ["Shartnoma tuziladi mi?","Ha, barcha mijozlar bilan rasmiy shartnoma imzolanadi. Xizmatlar, muddatlar, narxlar va natijalar aniq belgilanadi."],
            ["Natija bo'lmasa nima bo'ladi?","Shartnomada belgilangan natijaga erishilmasa, biz qo'shimcha to'lovsiz xizmatni davom ettiramiz yoki to'lovning bir qismini qaytaramiz."],
            ["Bir nechta xizmatni olsa bo'ladimi?","Ha, kompleks paket olganda narxda chegirma beriladi. Individual taklif uchun biz bilan bog'laning."],
        ],
        ticker:["SMM","TARGETING","SEO","WEB SAYT","TELEGRAM BOT","MOBIL DASTUR","BRANDING","ANALYTICS"],
        viewWork:"Loyihani ko'rish", startNow:"Hozir boshlash",
        itFeatures:["Responsive dizayn","Tez yuklash","SEO optimizatsiya","Admin panel"],
        itBotFeatures:["24/7 ishlaydi","Buyurtma qabul","To'lov integratsiya","Statistika"],
        itAppFeatures:["iOS & Android","Offline rejim","Push xabarnoma","Analitika"],
    },
    ru: {
        nav:["Услуги","IT Портфолио","Почему мы","Цены","Контакты"],
        navCta:"Связаться", eyebrow:"Агентство цифрового маркетинга",
        h1a:"Выведите бизнес", h1b:"в цифровое", h1c:"пространство",
        heroDesc:"SMM, таргетинг, SEO, сайты, Telegram-боты и мобильные приложения — все цифровые услуги для роста вашего бизнеса.",
        heroCta1:"Бесплатная консультация", heroCta2:"Услуги",
        s1:"Успешных проектов", s2:"Довольных клиентов", s3:"Лет опыта", s4:"Создано контента",
        svcLbl:"Услуги", svcT:["Что мы","делаем?"],
        whyLbl:"Почему мы?", whyT:["Почему выбирают","Zamon","?"],
        processT:"Как мы работаем?", processLbl:"Наш процесс",
        indLbl:"Опыт", indT:["В каких","отраслях","работаем?"],
        itLbl:"IT Услуги", itT:["Наше","IT Портфолио"],
        itDesc:"Сайты, Telegram-боты и мобильные приложения — познакомьтесь с нашими техническими решениями.",
        priceLbl:"Цены", priceT:["Тарифы","SMM"],
        priceMonth:"в месяц", pricePopular:"Популярный", priceCta:"Нужен индивидуальный пакет?", priceCtaLink:"Напишите нам",
        faqLbl:"FAQ", faqT:["Часто задаваемые","вопросы"],
        ctaLbl:"Контакты", ctaT:["Свяжитесь","с нами"],
        ctaDesc:"Сделайте первый шаг к развитию бизнеса. Предоставим бесплатную консультацию и индивидуальное предложение.",
        ctaAddress:"Олмазорский район, ул. Беруний 13А, Ташкент",
        footerDesc:"Профессиональное агентство цифрового маркетинга.",
        footerCol:["Услуги","Компания","Контакты"],
        copyright:"Все права защищены.",
        modalTitle:"Бесплатная консультация", modalDesc:"Оставьте данные — перезвоним в течение 15 минут.",
        modalName:"Имя и Фамилия", modalPhone:"Номер телефона", modalService:"Вид услуги (необязательно)",
        modalBtn:"Отправить", modalSuccess:"Спасибо!", modalSuccessDesc:"Свяжемся с вами в течение 15 минут.",
        modalReply:"Ответим за 15 минут", selectSvc:"Выберите...",
        svcs:["SMM","Таргетинг","SEO","Сайт","Telegram-бот","Мобильное приложение","Комплексный пакет"],
        whyItems:[
            ["Результативная стратегия","Для каждого проекта устанавливаем KPI."],
            ["Прозрачная отчётность","Еженедельные и ежемесячные отчёты с реальными показателями."],
            ["Быстрая связь","Отвечаем в Telegram в течение 15 минут. Всегда на связи."],
            ["Всё в одном месте","SMM, таргетинг, сайт, бот — все услуги в одном агентстве."],
        ],
        processSteps:[
            ["Анализ и стратегия","Изучаем ваш бизнес, конкурентов и целевую аудиторию"],
            ["Цели и KPI","Устанавливаем чёткие метрики и сроки достижения"],
            ["Реализация и оптимизация","Команда работает, результаты отслеживаем в реальном времени"],
            ["Отчёт и рост","Анализируем и обновляем стратегию на следующий месяц"],
        ],
        faqs:[
            ["Когда появятся результаты?","В таргете первые результаты через 3–7 дней. Органический рост SMM — через 1–2 месяца. SEO — через 3–6 месяцев."],
            ["Минимальный рекламный бюджет?","Рекомендуем минимум $200 в месяц. Это оптимальная сумма для охвата целевой аудитории."],
            ["Заключается ли договор?","Да, со всеми клиентами заключается официальный договор с чёткими условиями."],
            ["Что если не будет результата?","Если не достигнем оговорённых показателей, продолжим работу бесплатно или вернём часть оплаты."],
            ["Можно взять несколько услуг?","Да, при заказе комплексного пакета предоставляется скидка."],
        ],
        ticker:["SMM","ТАРГЕТИНГ","SEO","САЙТЫ","TELEGRAM-БОТ","МОБИЛЬНЫЕ ПРИЛОЖЕНИЯ","БРЕНДИНГ","АНАЛИТИКА"],
        viewWork:"Посмотреть проект", startNow:"Начать сейчас",
        itFeatures:["Адаптивный дизайн","Быстрая загрузка","SEO оптимизация","Панель управления"],
        itBotFeatures:["Работает 24/7","Приём заказов","Интеграция оплаты","Статистика"],
        itAppFeatures:["iOS & Android","Офлайн режим","Push уведомления","Аналитика"],
    },
};

/* ── SERVICES DATA ─────────────────────────────── */
const SVC_DATA = {
    uz:[
        {n:"01",Icon:TrendingUp,title:"SMM",full:"Social Media Marketing",desc:"Instagram, Facebook, Telegram kanallaringizni boshdan-oyoq boshqaramiz. Kontent strategiyasi, dizayn va auditoriya o'sishi.",tags:["Kontent","Dizayn","Strategiya"]},
        {n:"02",Icon:Target,title:"Targeting",full:"Maqsadli Reklama",desc:"Meta va Google platformalarida aniq auditoriyaga erishib, reklama byudjetingizdan maksimal daromad oling.",tags:["Meta Ads","Google Ads","A/B Test"]},
        {n:"03",Icon:Search,title:"SEO",full:"Qidiruv Optimallashtirish",desc:"Saytingizni Google birinchi sahifasiga olib chiqamiz. Texnik audit, kontent optimizatsiya va link building.",tags:["On-Page","Off-Page","Audit"]},
        {n:"04",Icon:Monitor,title:"Web Sayt",full:"Professional Saytlar",desc:"Konversiyaga yo'naltirilgan, tez yuklanadigan va zamonaviy dizayndagi veb-saytlar ishlab chiqamiz.",tags:["UI/UX","Frontend","Backend"]},
        {n:"05",Icon:Bot,title:"Telegram Bot",full:"Biznesni Avtomatlashtirish",desc:"Buyurtma qabul qilish, to'lov, yetkazib berish — barchasini 24/7 avtomatik ishlashini ta'minlaymiz.",tags:["Python","Node.js","API"]},
        {n:"06",Icon:Smartphone,title:"Mobil Dastur",full:"iOS & Android",desc:"Foydalanuvchi qulay, tez va chiroyli mobil ilovalar. Native va cross-platform texnologiyalarda ishlab chiqamiz.",tags:["React Native","Flutter","UX"]},
    ],
    ru:[
        {n:"01",Icon:TrendingUp,title:"SMM",full:"Маркетинг в соцсетях",desc:"Полное ведение Instagram, Facebook, Telegram. Контент-стратегия, дизайн, копирайтинг и рост аудитории.",tags:["Контент","Дизайн","Стратегия"]},
        {n:"02",Icon:Target,title:"Таргетинг",full:"Целевая реклама",desc:"Точный охват аудитории в Meta и Google. Максимальная отдача от рекламного бюджета.",tags:["Meta Ads","Google Ads","A/B Test"]},
        {n:"03",Icon:Search,title:"SEO",full:"Поисковая оптимизация",desc:"Выводим сайт на первые позиции Google. Технический аудит, оптимизация контента и линкбилдинг.",tags:["On-Page","Off-Page","Аудит"]},
        {n:"04",Icon:Monitor,title:"Сайт",full:"Профессиональные сайты",desc:"Современные, быстрые и конверсионные сайты с профессиональным дизайном.",tags:["UI/UX","Frontend","Backend"]},
        {n:"05",Icon:Bot,title:"Telegram-бот",full:"Автоматизация бизнеса",desc:"Приём заказов, оплата, доставка — всё работает 24/7 в автоматическом режиме.",tags:["Python","Node.js","API"]},
        {n:"06",Icon:Smartphone,title:"Мобильное приложение",full:"iOS & Android",desc:"Удобные, быстрые и красивые мобильные приложения на native и cross-platform технологиях.",tags:["React Native","Flutter","UX"]},
    ],
};

/* ── 6 SMM PLANS ───────────────────────────────── */
const PLANS = {
    uz:[
        {
            name:"BUSINESS LADY", price:"500", tag:null, color:"#818CF8",
            platform:"Instagram",
            note:"Ayollar biznesi uchun",
            smm:[
                "Biznes va raqobatchilarni tahlil qilish",
                "Brend strategiyasi va kontent plan",
                "12 ta Reels video (mobile) + Stories",
                "12 ta vizual dizayn (standart)",
                "Obunachilarni jalb qilish va ushlab turish",
            ],
            target:[
                "Maqsadli auditoriyani tahlil qilish",
                "Reklama kreativlari va matnlari",
                "Reklama kampaniyalarini ishga tushirish",
                "Natijalar bilan batafsil hisobotlar",
            ],
        },
        {
            name:"SIMPLE", price:"600", tag:null, color:"#9333EA",
            platform:"Instagram + Facebook",
            note:"Kichik va o'rta biznes",
            smm:[
                "Biznes va raqobatchilarni tahlil qilish",
                "Brend strategiyasi va kontent plan",
                "10 ta Reels video (mobile) + 5 ta SMD post",
                "10 ta vizual dizayn (standart)",
                "Obunachilarni jalb qilish va ushlab turish",
            ],
            target:[
                "Maqsadli auditoriyani tahlil qilish",
                "Reklama kreativlari va matnlari",
                "Reklama kampaniyalarini ishga tushirish",
                "Natijalar bilan batafsil hisobotlar",
            ],
        },
        {
            name:"BUSINESS", price:"900", tag:"Mashhur", color:"#E879F9",
            platform:"Instagram + Facebook + Telegram",
            note:"Faol o'sish uchun",
            smm:[
                "Biznes va raqobatchilarni tahlil qilish",
                "Brend strategiyasi va kontent plan",
                "20 ta video Reels (mobile) + 45 ta Stories",
                "20 ta vizual dizayn (standart)",
                "Obunachilarni jalb qilish va ushlab turish",
            ],
            target:[
                "Maqsadli auditoriyani tahlil qilish",
                "Reklama kreativlari va matnlari",
                "Reklama kampaniyalarini ishga tushirish",
                "Natijalar bilan batafsil hisobotlar",
            ],
        },
        {
            name:"PREMIUM", price:"1500", tag:null, color:"#A855F7",
            platform:"Instagram + Facebook + Telegram",
            note:"Professional darajada",
            smm:[
                "Biznes va raqobatchilarni tahlil qilish",
                "Brend strategiyasi va kontent plan",
                "10 ta Reels video (camera) + 5 ta SMD + Stories",
                "10 ta vizual dizayn (professional)",
                "Obunachilarni jalb qilish va ushlab turish",
            ],
            target:[
                "Maqsadli auditoriyani tahlil qilish",
                "Reklama kreativlari va matnlari",
                "Reklama kampaniyalarini ishga tushirish",
                "Natijalar bilan batafsil hisobotlar",
                "Target kreativ: alohida 10 ta video (mobile)",
            ],
        },
        {
            name:"PREMIUM+", price:"3000", tag:"VIP", color:"#F472B6",
            platform:"Instagram + Facebook + Telegram + YouTube Shorts",
            note:"Korporativ to'liq yechim",
            smm:[
                "Biznes va raqobatchilarni tahlil qilish",
                "Brend strategiyasi va kontent plan",
                "16 ta Reels video (camera) + 8 ta AI kontent + Stories",
                "16 ta vizual dizayn (professional)",
                "Obunachilarni jalb qilish va ushlab turish",
            ],
            target:[
                "Maqsadli auditoriyani tahlil qilish",
                "Reklama kreativlari va matnlari",
                "Reklama kampaniyalari (Meta Ads + TG Ads)",
                "Natijalar bilan batafsil hisobotlar",
                "Target kreativ: alohida 10 ta video (mobile)",
                "Brandface xizmati",
                "Direct manager (10:00 — 18:00)",
                "Korporativ sayt",
            ],
        },
    ],
    ru:[
        {
            name:"BUSINESS LADY", price:"500", tag:null, color:"#818CF8",
            platform:"Instagram",
            note:"Для женского бизнеса",
            smm:[
                "Анализ бизнеса и конкурентов",
                "Стратегия бренда и контент-план",
                "12 Reels видео (mobile) + Stories",
                "12 визуальных дизайнов (стандарт)",
                "Привлечение и удержание подписчиков",
            ],
            target:[
                "Анализ целевой аудитории",
                "Рекламные креативы и тексты",
                "Запуск рекламных кампаний",
                "Подробные отчёты с результатами",
            ],
        },
        {
            name:"SIMPLE", price:"600", tag:null, color:"#9333EA",
            platform:"Instagram + Facebook",
            note:"Для малого и среднего бизнеса",
            smm:[
                "Анализ бизнеса и конкурентов",
                "Стратегия бренда и контент-план",
                "10 Reels видео (mobile) + 5 SMD постов",
                "10 визуальных дизайнов (стандарт)",
                "Привлечение и удержание подписчиков",
            ],
            target:[
                "Анализ целевой аудитории",
                "Рекламные креативы и тексты",
                "Запуск рекламных кампаний",
                "Подробные отчёты с результатами",
            ],
        },
        {
            name:"BUSINESS", price:"900", tag:"Популярный", color:"#E879F9",
            platform:"Instagram + Facebook + Telegram",
            note:"Для активного роста",
            smm:[
                "Анализ бизнеса и конкурентов",
                "Стратегия бренда и контент-план",
                "20 Reels видео (mobile) + 45 Stories",
                "20 визуальных дизайнов (стандарт)",
                "Привлечение и удержание подписчиков",
            ],
            target:[
                "Анализ целевой аудитории",
                "Рекламные креативы и тексты",
                "Запуск рекламных кампаний",
                "Подробные отчёты с результатами",
            ],
        },
        {
            name:"PREMIUM", price:"1500", tag:null, color:"#A855F7",
            platform:"Instagram + Facebook + Telegram",
            note:"Профессиональный уровень",
            smm:[
                "Анализ бизнеса и конкурентов",
                "Стратегия бренда и контент-план",
                "10 Reels видео (camera) + 5 SMD + Stories",
                "10 визуальных дизайнов (профессиональный)",
                "Привлечение и удержание подписчиков",
            ],
            target:[
                "Анализ целевой аудитории",
                "Рекламные креативы и тексты",
                "Запуск рекламных кампаний",
                "Подробные отчёты с результатами",
                "Отдельно 10 видео для таргет-креативов (mobile)",
            ],
        },
        {
            name:"PREMIUM+", price:"3000", tag:"VIP", color:"#F472B6",
            platform:"Instagram + Facebook + Telegram + YouTube Shorts",
            note:"Корпоративное комплексное решение",
            smm:[
                "Анализ бизнеса и конкурентов",
                "Стратегия бренда и контент-план",
                "16 Reels видео (camera) + 8 AI контент + Stories",
                "16 визуальных дизайнов (профессиональный)",
                "Привлечение и удержание подписчиков",
            ],
            target:[
                "Анализ целевой аудитории",
                "Рекламные креативы и тексты",
                "Запуск кампаний (Meta Ads + TG Ads)",
                "Подробные отчёты с результатами",
                "Отдельно 10 видео для таргет-креативов (mobile)",
                "Услуга Brandface",
                "Direct manager (10:00 — 18:00)",
                "Корпоративный сайт",
            ],
        },
    ],
};

const INDUSTRIES = {
    uz:[{label:"Restoran & Cafe",count:"28+"},{label:"Klinika & Tibbiyot",count:"19+"},{label:"Ta'lim & Kurslar",count:"34+"},{label:"Savdo & E-commerce",count:"41+"},{label:"Qurilish & Ko'chmas mulk",count:"22+"},{label:"Fitnes & Sport",count:"15+"}],
    ru:[{label:"Рестораны & Кафе",count:"28+"},{label:"Клиники & Медицина",count:"19+"},{label:"Образование & Курсы",count:"34+"},{label:"Торговля & E-commerce",count:"41+"},{label:"Строительство & Недвижимость",count:"22+"},{label:"Фитнес & Спорт",count:"15+"}],
};

const WHY_ICONS=[Award,BarChart2,Zap,Shield];
const PROC_ICONS=[Search,Target,TrendingUp,BarChart2];

/* ── IT PORTFOLIO DATA ─────────────────────────── */
const IT_PROJECTS = {
    uz:[
        {
            type:"bot", Icon:Bot, label:"Telegram Bot", cat:"Internet Magazin Bot",
            title:"FAXMarket — Do'kon Bot",
            tech:["Python","Aiogram","SQLite","Admin Panel"],
            color:"#818CF8",
            link:"https://t.me/FAXmarket_bot",
            features:["2 tilli (UZ/RU)","Mahsulot katalogi","Maxsus adminka","Lokatsiya aniqlash"],
            desc:"Internet-magazin uchun Telegram bot. Rus va o'zbek tillarida ishlaydi. Mahsulotlar qo'shish va o'zgartirish uchun maxsus adminka. Lokatsiya bo'yicha manzil aniqlash funksiyasi mavjud. Python Aiogram orqali 0 dan yozilgan.",
        },
        {
            type:"web", Icon:Monitor, label:"Web Sayt", cat:"Korporativ Sayt",
            title:"uzkoj.uz — Ko'zi Ojizlar Jamiyati",
            tech:["Python","Django","React JS"],
            color:"#9333EA",
            link:"https://uzkoj.uz",
            features:["Ko'p tilli sayt","Maxsus dizayn","10+ sahifa","0 dan yozilgan"],
            desc:"O'zbekiston Ko'zi ojizlar jamiyatining rasmiy korporativ sayti. Ko'p tilli interfeys, maxsus dizayn, 10 dan ortiq sahifalar. Python Django va React JS texnologiyalarida 0 dan ishlab chiqilgan.",
        },
        {
            type:"bot", Icon:Bot, label:"Telegram Bot", cat:"Kargo Xizmati Bot",
            title:"FxExpress — Kargo Bot",
            tech:["Python","Aiogram","PostgreSQL"],
            color:"#E879F9",
            link:"https://t.me/FxExpress_bot",
            features:["Kargo kuzatish","Buyurtma qabul","Avtomatik xabar","Admin panel"],
            desc:"Kargo va yetkazib berish xizmati bilan shug'ullanadigan kompaniya uchun Telegram bot. Buyurtmalarni qabul qilish, kuzatish va mijozlarga avtomatik xabarnoma yuborish.",
        },
        {
            type:"bot", Icon:Bot, label:"Telegram Web App", cat:"Cafe Internet Magazin",
            title:"Beanberry — Cafe Bot",
            tech:["Python","Aiogram","Web App","API"],
            color:"#A855F7",
            link:"https://t.me/BeanberryOfficialBot",
            features:["Telegram Web App","Menyu katalogi","Onlayn buyurtma","To'lov tizimi"],
            desc:"Beanberry cafe uchun Telegram Web App asosidagi internet-magazin bot. Interaktiv menyu, onlayn buyurtma va to'lov tizimi bitta ilovada — Telegram ichidan chiqmasdan.",
        },
        {
            type:"web", Icon:Layout, label:"Web Sayt", cat:"Korporativ Sayt",
            title:"texla.uz — TEXLAB Laboratoriya",
            tech:["React JS","Node.js","CMS"],
            color:"#F472B6",
            link:"https://texla.uz",
            features:["Mahsulot katalogi","Ko'p tilli","SEO optimizatsiya","Admin panel"],
            desc:"TEXLAB qo'shma korxonasi — O'zbekistondagi yuqori sifatli laboratoriya uskunalari yetkazib beruvchisi uchun korporativ sayt. Mahsulot katalogi, SEO optimizatsiya va admin panel.",
        },
        {
            type:"web", Icon:Layers, label:"Web Sayt", cat:"Ta'lim Platformasi",
            title:"vipmag.org — VIP Podcasts",
            tech:["React JS","Next.js","Tailwind"],
            color:"#818CF8",
            link:"https://vipmag.org",
            features:["Podcast kurslari","Mentor tizimi","Interaktiv darslar","Ingliz tili"],
            desc:"Very Important Podcasts Magazine — real podcastlar va professional mentorlar orqali ingliz tilini o'rgatadigan ta'lim platformasi. Interaktiv kurslar va audio darslar.",
        },
    ],
    ru:[
        {
            type:"bot", Icon:Bot, label:"Telegram Bot", cat:"Интернет-магазин бот",
            title:"FAXMarket — Бот магазина",
            tech:["Python","Aiogram","SQLite","Admin Panel"],
            color:"#818CF8",
            link:"https://t.me/FAXmarket_bot",
            features:["2 языка (UZ/RU)","Каталог товаров","Спец. админка","Определение локации"],
            desc:"Telegram-бот для интернет-магазина. Работает на русском и узбекском языках. Специальная админка для управления товарами. Функция определения адреса по геолокации. Написан с нуля на Python Aiogram.",
        },
        {
            type:"web", Icon:Monitor, label:"Сайт", cat:"Корпоративный сайт",
            title:"uzkoj.uz — Общество слабовидящих",
            tech:["Python","Django","React JS"],
            color:"#9333EA",
            link:"https://uzkoj.uz",
            features:["Многоязычный","Уникальный дизайн","10+ страниц","С нуля"],
            desc:"Официальный корпоративный сайт Общества слабовидящих Узбекистана. Многоязычный интерфейс, уникальный дизайн, более 10 страниц. Разработан с нуля на Python Django и React JS.",
        },
        {
            type:"bot", Icon:Bot, label:"Telegram Bot", cat:"Бот карго-службы",
            title:"FxExpress — Карго бот",
            tech:["Python","Aiogram","PostgreSQL"],
            color:"#E879F9",
            link:"https://t.me/FxExpress_bot",
            features:["Отслеживание груза","Приём заказов","Авто-уведомления","Admin панель"],
            desc:"Telegram-бот для компании, занимающейся карго и доставкой. Приём заказов, отслеживание груза и автоматические уведомления клиентам.",
        },
        {
            type:"bot", Icon:Bot, label:"Telegram Web App", cat:"Интернет-магазин кафе",
            title:"Beanberry — Бот кафе",
            tech:["Python","Aiogram","Web App","API"],
            color:"#A855F7",
            link:"https://t.me/BeanberryOfficialBot",
            features:["Telegram Web App","Каталог меню","Онлайн заказ","Оплата"],
            desc:"Интернет-магазин на базе Telegram Web App для кафе Beanberry. Интерактивное меню, онлайн-заказ и оплата — всё внутри Telegram без установки отдельного приложения.",
        },
        {
            type:"web", Icon:Layout, label:"Сайт", cat:"Корпоративный сайт",
            title:"texla.uz — TEXLAB Лаборатории",
            tech:["React JS","Node.js","CMS"],
            color:"#F472B6",
            link:"https://texla.uz",
            features:["Каталог продукции","Многоязычный","SEO оптимизация","Admin панель"],
            desc:"Корпоративный сайт TEXLAB — ведущего поставщика лабораторного оборудования и инвентаря в Узбекистане. Каталог продукции, SEO оптимизация и панель управления.",
        },
        {
            type:"web", Icon:Layers, label:"Сайт", cat:"Образовательная платформа",
            title:"vipmag.org — VIP Podcasts",
            tech:["React JS","Next.js","Tailwind"],
            color:"#818CF8",
            link:"https://vipmag.org",
            features:["Подкаст-курсы","Система менторов","Интерактивные уроки","Английский язык"],
            desc:"Very Important Podcasts Magazine — образовательная платформа для изучения английского языка через реальные подкасты и профессиональных менторов. Интерактивные курсы и аудио-уроки.",
        },
    ],
};

/* ── COUNTER ───────────────────────────────────── */
function useCountUp(end,dur,trigger){
    const[v,setV]=useState(0);
    useEffect(()=>{
        if(!trigger)return;
        let s=0;const step=end/(dur/16);
        const t=setInterval(()=>{s=Math.min(s+step,end);setV(Math.floor(s));if(s>=end)clearInterval(t);},16);
        return()=>clearInterval(t);
    },[trigger,end,dur]);
    return v;
}

/* ── INPUT STYLE ───────────────────────────────── */
const IS={width:"100%",background:"rgba(19,12,30,0.85)",border:"1px solid rgba(240,236,255,0.08)",color:"#F0ECFF",padding:"12px 14px",fontFamily:"'Outfit',sans-serif",fontSize:14,fontWeight:500,outline:"none",borderRadius:6,transition:"border-color .25s,box-shadow .25s",display:"block"};
const onFoc=e=>{e.target.style.borderColor="rgba(147,51,234,.55)";e.target.style.boxShadow="0 0 0 3px rgba(147,51,234,.12)";};
const onBlr=e=>{e.target.style.borderColor="rgba(240,236,255,.08)";e.target.style.boxShadow="none";};

/* ── INLINE FORM ───────────────────────────────── */
function InlineForm({t,lang}){
    const[f,setF]=useState({name:"",phone:"",service:""});
    const[loading,setLoading]=useState(false);
    const[done,setDone]=useState(false);
    const sub=async(e)=>{e.preventDefault();setLoading(true);await sendToTelegram(f.name,f.phone,f.service,lang);setLoading(false);setDone(true);};
    if(done)return(
        <div style={{textAlign:"center",padding:"20px 0"}}>
            <div style={{width:48,height:48,background:"rgba(147,51,234,.15)",border:"1px solid rgba(147,51,234,.3)",borderRadius:50,display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 14px"}}><CheckCircle size={22} color="#E879F9"/></div>
            <div style={{fontFamily:"'Bricolage Grotesque',sans-serif",fontSize:19,fontWeight:700,marginBottom:6}}>{t.modalSuccess}</div>
            <p style={{color:"rgba(240,236,255,.5)",fontSize:13}}>{t.modalSuccessDesc}</p>
        </div>
    );
    return(
        <form onSubmit={sub}>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
                <div>
                    <label style={{display:"flex",alignItems:"center",gap:5,fontSize:10,fontWeight:700,letterSpacing:".13em",textTransform:"uppercase",color:"rgba(240,236,255,.4)",marginBottom:7}}><Users size={10}/>{t.modalName}</label>
                    <input style={IS} placeholder={t.modalName} value={f.name} onChange={e=>setF({...f,name:e.target.value})} required onFocus={onFoc} onBlur={onBlr}/>
                </div>
                <div>
                    <label style={{display:"flex",alignItems:"center",gap:5,fontSize:10,fontWeight:700,letterSpacing:".13em",textTransform:"uppercase",color:"rgba(240,236,255,.4)",marginBottom:7}}><Phone size={10}/>{t.modalPhone}</label>
                    <input style={IS} placeholder="+998 XX XXX XX XX" type="tel" value={f.phone} onChange={e=>setF({...f,phone:e.target.value})} required onFocus={onFoc} onBlur={onBlr}/>
                </div>
            </div>
            <div style={{marginBottom:18}}>
                <label style={{display:"flex",alignItems:"center",gap:5,fontSize:10,fontWeight:700,letterSpacing:".13em",textTransform:"uppercase",color:"rgba(240,236,255,.4)",marginBottom:7}}><Zap size={10}/>{t.modalService}</label>
                <select style={{...IS,appearance:"none"}} value={f.service} onChange={e=>setF({...f,service:e.target.value})} onFocus={onFoc} onBlur={onBlr}>
                    <option value="">{t.selectSvc}</option>
                    {t.svcs.map(s=><option key={s} style={{background:"#130C1E"}}>{s}</option>)}
                </select>
            </div>
            <button type="submit" disabled={loading} style={{width:"100%",background:loading?"rgba(147,51,234,.5)":"linear-gradient(135deg,#9333EA,#E879F9)",border:"none",borderRadius:6,padding:"13px",color:"#fff",fontFamily:"'Outfit',sans-serif",fontWeight:700,fontSize:12,letterSpacing:".07em",textTransform:"uppercase",cursor:loading?"not-allowed":"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8,transition:"all .3s"}}
                    onMouseEnter={e=>{if(!loading){e.currentTarget.style.transform="translateY(-1px)";e.currentTarget.style.boxShadow="0 8px 28px rgba(147,51,234,.4)";}}}
                    onMouseLeave={e=>{e.currentTarget.style.transform="none";e.currentTarget.style.boxShadow="none";}}>
                {loading?<><Clock size={13}/>...</>:<><Send size={13}/><span>{t.modalBtn}</span></>}
            </button>
            <p style={{textAlign:"center",fontSize:10,color:"rgba(240,236,255,.18)",marginTop:10,display:"flex",alignItems:"center",justifyContent:"center",gap:5}}>
                <Clock size={9}/>{t.modalReply}
            </p>
        </form>
    );
}

/* ── MODAL ─────────────────────────────────────── */
function Modal({open,onClose,lang}){
    const t=T[lang];
    const[f,setF]=useState({name:"",phone:"",service:""});
    const[loading,setLoading]=useState(false);
    const[done,setDone]=useState(false);
    useEffect(()=>{if(open){setF({name:"",phone:"",service:""});setLoading(false);setDone(false);}document.body.style.overflow=open?"hidden":"";return()=>{document.body.style.overflow=""};},[open]);
    useEffect(()=>{const h=e=>e.key==="Escape"&&onClose();window.addEventListener("keydown",h);return()=>window.removeEventListener("keydown",h);},[onClose]);
    const sub=async(e)=>{e.preventDefault();setLoading(true);await sendToTelegram(f.name,f.phone,f.service,lang);setLoading(false);setDone(true);};
    if(!open)return null;
    return(
        <div style={{position:"fixed",inset:0,zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
            <div onClick={onClose} style={{position:"absolute",inset:0,background:"rgba(5,3,10,.88)",backdropFilter:"blur(14px)"}}/>
            <div style={{position:"relative",width:"100%",maxWidth:460,background:"#0D0916",border:"1px solid rgba(240,236,255,.1)",borderRadius:12,overflow:"hidden",boxShadow:"0 40px 100px rgba(0,0,0,.7)"}}>
                <div style={{height:2,background:"linear-gradient(90deg,#9333EA,#E879F9,#818CF8)"}}/>
                <div style={{padding:"30px 30px 34px"}}>
                    <button onClick={onClose} style={{position:"absolute",top:14,right:14,background:"rgba(240,236,255,.06)",border:"1px solid rgba(240,236,255,.08)",borderRadius:6,width:30,height:30,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",color:"rgba(240,236,255,.45)",transition:"all .2s"}}
                            onMouseEnter={e=>{e.currentTarget.style.background="rgba(240,236,255,.1)";e.currentTarget.style.color="#F0ECFF";}}
                            onMouseLeave={e=>{e.currentTarget.style.background="rgba(240,236,255,.06)";e.currentTarget.style.color="rgba(240,236,255,.45)";}}>
                        <ChevronDown size={13} style={{transform:"rotate(225deg)"}}/>
                    </button>
                    {done?(
                        <div style={{textAlign:"center",padding:"18px 0"}}>
                            <div style={{width:54,height:54,background:"rgba(147,51,234,.15)",border:"1px solid rgba(147,51,234,.3)",borderRadius:50,display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 18px"}}><CheckCircle size={24} color="#E879F9"/></div>
                            <div style={{fontFamily:"'Bricolage Grotesque',sans-serif",fontSize:22,fontWeight:700,marginBottom:8}}>{t.modalSuccess}</div>
                            <p style={{color:"rgba(240,236,255,.5)",fontSize:14,lineHeight:1.7}}>{t.modalSuccessDesc}</p>
                        </div>
                    ):(
                        <>
                            <div style={{marginBottom:22}}>
                                <div style={{fontFamily:"'Bricolage Grotesque',sans-serif",fontSize:21,fontWeight:700,marginBottom:5}}>{t.modalTitle}</div>
                                <p style={{fontSize:13,color:"rgba(240,236,255,.44)",lineHeight:1.6}}>{t.modalDesc}</p>
                            </div>
                            <InlineForm t={t} lang={lang}/>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

/* ── PRICING SLIDER ────────────────────────────── */
function PlanFeatureRow({label,color}){
    return(
        <div style={{display:"flex",alignItems:"flex-start",gap:9,fontSize:12,color:"rgba(240,236,255,.72)",marginBottom:8,fontWeight:400,lineHeight:1.5}}>
            <div style={{width:5,height:5,borderRadius:"50%",background:color,flexShrink:0,marginTop:5}}/>
            {label}
        </div>
    );
}

function PricingSlider({plans,t,onModal,lang}){
    const[idx,setIdx]=useState(0);
    const trackRef=useRef(null);
    const VISIBLE=3;
    const max=Math.max(0,plans.length-VISIBLE);
    const prev=()=>setIdx(i=>Math.max(0,i-1));
    const next=()=>setIdx(i=>Math.min(max,i+1));

    useEffect(()=>{
        const update=()=>{
            if(trackRef.current){
                const card=trackRef.current.querySelector(".pslide");
                if(card){
                    const w=card.offsetWidth+20;
                    trackRef.current.style.transform=`translateX(-${idx*w}px)`;
                }
            }
        };
        update();
        window.addEventListener("resize",update);
        return()=>window.removeEventListener("resize",update);
    },[idx]);

    const smmLabel = lang==="uz"?"SMM xizmati":"SMM услуга";
    const tgLabel  = lang==="uz"?"Target xizmati":"Таргетинг";

    return(
        <div>
            {/* controls */}
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:28}}>
                <div style={{display:"flex",gap:6,alignItems:"center"}}>
                    {plans.map((_,i)=>(
                        <button key={i} onClick={()=>setIdx(Math.min(i,max))}
                                style={{width:i>=idx&&i<idx+VISIBLE?24:7,height:7,borderRadius:4,
                                    background:i>=idx&&i<idx+VISIBLE?"#9333EA":"rgba(240,236,255,.12)",
                                    border:"none",cursor:"pointer",transition:"all .35s",padding:0}}/>
                    ))}
                    <span style={{fontSize:11,color:"rgba(240,236,255,.3)",marginLeft:8,fontWeight:600}}>
                        {idx+1}–{Math.min(idx+VISIBLE,plans.length)} / {plans.length}
                    </span>
                </div>
                <div style={{display:"flex",gap:8}}>
                    <button onClick={prev} disabled={idx===0}
                            style={{width:36,height:36,borderRadius:"50%",background:"rgba(240,236,255,.05)",border:"1px solid rgba(240,236,255,.1)",display:"flex",alignItems:"center",justifyContent:"center",cursor:idx===0?"not-allowed":"pointer",opacity:idx===0?.3:1,color:"#F0ECFF",transition:"all .25s"}}
                            onMouseEnter={e=>{if(idx>0)e.currentTarget.style.background="rgba(147,51,234,.2)";}}
                            onMouseLeave={e=>{e.currentTarget.style.background="rgba(240,236,255,.05)";}}>
                        <ChevronLeft size={15}/>
                    </button>
                    <button onClick={next} disabled={idx>=max}
                            style={{width:36,height:36,borderRadius:"50%",background:"rgba(240,236,255,.05)",border:"1px solid rgba(240,236,255,.1)",display:"flex",alignItems:"center",justifyContent:"center",cursor:idx>=max?"not-allowed":"pointer",opacity:idx>=max?.3:1,color:"#F0ECFF",transition:"all .25s"}}
                            onMouseEnter={e=>{if(idx<max)e.currentTarget.style.background="rgba(147,51,234,.2)";}}
                            onMouseLeave={e=>{e.currentTarget.style.background="rgba(240,236,255,.05)";}}>
                        <ChevronRight size={15}/>
                    </button>
                </div>
            </div>

            {/* track */}
            <div style={{overflow:"hidden",margin:"0 -4px"}}>
                <div ref={trackRef} style={{display:"flex",gap:20,transition:"transform .45s cubic-bezier(.4,0,.2,1)",padding:"4px 4px 12px",willChange:"transform"}}>
                    {plans.map((p,i)=>(
                        <div key={i} className="pslide" style={{
                            minWidth:"calc(33.333% - 14px)",
                            background:p.tag?"rgba(28,6,44,.97)":"rgba(13,9,22,.97)",
                            border:`1px solid ${p.tag?"rgba(232,121,249,.3)":"rgba(240,236,255,.07)"}`,
                            borderRadius:12,padding:"0 0 24px",position:"relative",flexShrink:0,
                            boxShadow:p.tag?"0 0 50px rgba(232,121,249,.1)":"none",
                            transition:"transform .3s,box-shadow .3s",overflow:"hidden",
                        }}
                             onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-5px)";e.currentTarget.style.boxShadow="0 20px 50px rgba(147,51,234,.2)";}}
                             onMouseLeave={e=>{e.currentTarget.style.transform="none";e.currentTarget.style.boxShadow=p.tag?"0 0 50px rgba(232,121,249,.1)":"none";}}>

                            {/* top color bar */}
                            <div style={{height:3,background:`linear-gradient(90deg,${p.color},${p.color}88)`,borderRadius:"12px 12px 0 0"}}/>

                            <div style={{padding:"22px 24px 0"}}>
                                {/* badge */}
                                {p.tag&&(
                                    <div style={{position:"absolute",top:18,right:16,fontSize:9,fontWeight:800,letterSpacing:".16em",textTransform:"uppercase",color:"#05030A",background:p.color,padding:"3px 10px",borderRadius:3}}>
                                        {p.tag}
                                    </div>
                                )}

                                {/* name */}
                                <div style={{fontSize:11,fontWeight:800,letterSpacing:".18em",textTransform:"uppercase",color:p.color,marginBottom:14}}>
                                    {p.name}
                                </div>

                                {/* price */}
                                <div style={{fontFamily:"'Bricolage Grotesque',sans-serif",fontSize:"clamp(34px,3.8vw,50px)",fontWeight:800,letterSpacing:"-0.03em",lineHeight:1,color:"#F0ECFF",marginBottom:3}}>
                                    <span style={{fontSize:".36em",verticalAlign:"super",fontWeight:700,color:"rgba(240,236,255,.4)"}}>$</span>
                                    {p.price}
                                </div>
                                <div style={{fontSize:11,color:"rgba(240,236,255,.3)",marginBottom:4}}>{t.priceMonth}</div>
                                <div style={{fontSize:11,color:p.color,fontWeight:600,marginBottom:16,letterSpacing:".02em"}}>{p.note}</div>

                                {/* platform pill */}
                                <div style={{display:"inline-flex",alignItems:"center",gap:6,background:`${p.color}14`,border:`1px solid ${p.color}30`,borderRadius:100,padding:"4px 12px",fontSize:10,fontWeight:700,color:p.color,letterSpacing:".04em",marginBottom:20}}>
                                    <Globe size={9}/> {p.platform}
                                </div>

                                <div style={{height:1,background:"rgba(240,236,255,.06)",marginBottom:16}}/>

                                {/* SMM section */}
                                <div style={{marginBottom:14}}>
                                    <div style={{display:"flex",alignItems:"center",gap:7,fontSize:10,fontWeight:800,letterSpacing:".12em",textTransform:"uppercase",color:"rgba(240,236,255,.55)",marginBottom:10}}>
                                        <TrendingUp size={11} color={p.color}/> {smmLabel}
                                    </div>
                                    {p.smm.map(f=><PlanFeatureRow key={f} label={f} color={p.color}/>)}
                                </div>

                                <div style={{height:1,background:"rgba(240,236,255,.06)",marginBottom:14}}/>

                                {/* Target section */}
                                <div style={{marginBottom:22}}>
                                    <div style={{display:"flex",alignItems:"center",gap:7,fontSize:10,fontWeight:800,letterSpacing:".12em",textTransform:"uppercase",color:"rgba(240,236,255,.55)",marginBottom:10}}>
                                        <Target size={11} color={p.color}/> {tgLabel}
                                    </div>
                                    {p.target.map(f=><PlanFeatureRow key={f} label={f} color={p.color}/>)}
                                </div>

                                <button onClick={onModal}
                                        style={{width:"100%",background:p.tag?`linear-gradient(135deg,${p.color},#9333EA)`:"transparent",
                                            border:p.tag?"none":`1px solid ${p.color}40`,
                                            borderRadius:6,padding:"12px",color:"#fff",
                                            fontFamily:"'Outfit',sans-serif",fontWeight:700,fontSize:12,
                                            letterSpacing:".07em",textTransform:"uppercase",cursor:"pointer",
                                            transition:"all .3s",display:"flex",alignItems:"center",justifyContent:"center",gap:7}}
                                        onMouseEnter={e=>{if(!p.tag){e.currentTarget.style.background=`${p.color}20`;e.currentTarget.style.borderColor=p.color;}}}
                                        onMouseLeave={e=>{if(!p.tag){e.currentTarget.style.background="transparent";e.currentTarget.style.borderColor=`${p.color}40`;}}}>
                                    {lang==="uz"?"Tanlash":"Выбрать"}<ArrowRight size={13}/>
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

/* ── APP ───────────────────────────────────────── */
let lang="uz"; // module-level so PricingSlider can access
export default function App(){
    const[language,setLanguage]=useState("uz");
    lang=language;
    const[menuOpen,setMenuOpen]=useState(false);
    const[modal,setModal]=useState(false);
    const[openFaq,setOpenFaq]=useState(null);
    const[statsVisible,setStatsVisible]=useState(false);
    const[heroVisible,setHeroVisible]=useState(false);
    const statsRef=useRef(null);
    const t=T[language];

    // Hero counters: sahifa ochilgandan 600ms keyin
    useEffect(()=>{
        const timer=setTimeout(()=>setHeroVisible(true),600);
        return()=>clearTimeout(timer);
    },[]);

    // Stats section: viewportga kirganda
    useEffect(()=>{
        const obs=new IntersectionObserver(([e])=>{if(e.isIntersecting)setStatsVisible(true);},{threshold:.3});
        if(statsRef.current)obs.observe(statsRef.current);
        return()=>obs.disconnect();
    },[]);

    // Hero strip counters (tezroq trigger)
    const h1=useCountUp(150,1600,heroVisible);
    const h2=useCountUp(98,1400,heroVisible);
    const h3=useCountUp(3,1200,heroVisible);

    // Stats section counters
    const c1=useCountUp(150,1600,statsVisible);
    const c2=useCountUp(98,1400,statsVisible);
    const c3=useCountUp(3,1200,statsVisible);
    const c4=useCountUp(500,2000,statsVisible);

    const scrollTo=id=>{document.getElementById(id)?.scrollIntoView({behavior:"smooth"});setMenuOpen(false);};
    const navIds=["services","it-portfolio","why","pricing","contact"];

    return(
        <div style={{fontFamily:"'Outfit',sans-serif",background:"#05030A",color:"#F0ECFF",overflowX:"hidden"}}>
            <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,400;12..96,600;12..96,700;12..96,800&family=Outfit:wght@300;400;500;600;700;800&display=swap');
        :root{--bg:#05030A;--s1:#0D0916;--s2:#130C1E;--v:#9333EA;--p:#E879F9;--i:#818CF8;--w:#F0ECFF;--m:rgba(240,236,255,.42);--b:rgba(240,236,255,.07);--b2:rgba(240,236,255,.13);--g:clamp(20px,5vw,76px);}
        *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
        html{scroll-behavior:smooth;}
        ::-webkit-scrollbar{width:3px;}::-webkit-scrollbar-track{background:#05030A;}::-webkit-scrollbar-thumb{background:#9333EA;border-radius:3px;}
        h1,h2,h3,h4{font-family:'Bricolage Grotesque',sans-serif;font-weight:800;}
        .gtext{background:linear-gradient(130deg,#E879F9 0%,#9333EA 55%,#818CF8 100%);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;}
        .stroke{-webkit-text-stroke:1.5px rgba(240,236,255,.18);color:transparent;font-family:'Bricolage Grotesque',sans-serif;font-weight:800;}
        .grain{position:fixed;inset:0;pointer-events:none;z-index:9999;opacity:.03;background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='300'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='300' height='300' filter='url(%23n)'/%3E%3C/svg%3E");background-size:300px;}
        nav{position:fixed;top:0;left:0;right:0;z-index:200;padding:17px var(--g);display:flex;align-items:center;justify-content:space-between;background:rgba(5,3,10,.8);backdrop-filter:blur(22px);border-bottom:1px solid var(--b);}
        .nlogo{font-family:'Bricolage Grotesque',sans-serif;font-weight:800;font-size:20px;letter-spacing:.05em;color:var(--w);cursor:pointer;display:flex;align-items:center;gap:8px;}
        .ndot{width:7px;height:7px;background:var(--p);border-radius:50%;box-shadow:0 0 8px var(--p);animation:blink 2s ease-in-out infinite;}
        .nlinks{display:flex;gap:26px;list-style:none;}
        .nlinks a{color:var(--m);font-size:12px;font-weight:600;letter-spacing:.05em;text-transform:uppercase;text-decoration:none;cursor:pointer;transition:color .25s;position:relative;}
        .nlinks a::after{content:'';position:absolute;bottom:-4px;left:0;right:0;height:1px;background:var(--p);transform:scaleX(0);transform-origin:left;transition:transform .3s;}
        .nlinks a:hover{color:var(--w);}.nlinks a:hover::after{transform:scaleX(1);}
        .nright{display:flex;align-items:center;gap:8px;}
        .lbtn{background:transparent;border:1px solid var(--b2);color:var(--m);padding:7px 11px;font-family:'Outfit',sans-serif;font-weight:700;font-size:11px;letter-spacing:.08em;cursor:pointer;border-radius:4px;transition:all .25s;display:flex;align-items:center;gap:5px;}
        .lbtn:hover{border-color:var(--v);color:var(--w);}
        .lbtn.on{background:rgba(147,51,234,.18);border-color:var(--v);color:var(--w);}
        .ncta{background:transparent;border:1px solid var(--b2);color:var(--w);padding:9px 19px;font-family:'Outfit',sans-serif;font-weight:700;font-size:11px;letter-spacing:.08em;text-transform:uppercase;cursor:pointer;border-radius:4px;transition:all .3s;}
        .ncta:hover{background:var(--v);border-color:var(--v);box-shadow:0 0 20px rgba(147,51,234,.4);}
        .ham{display:none;flex-direction:column;gap:5px;cursor:pointer;padding:4px;background:none;border:none;}
        .ham span{display:block;width:20px;height:1.5px;background:var(--w);transition:all .35s;}
        .mmenu{position:fixed;inset:0;z-index:199;background:rgba(5,3,10,.97);backdrop-filter:blur(28px);display:flex;flex-direction:column;align-items:center;justify-content:center;gap:22px;transform:translateY(-100%);transition:transform .5s cubic-bezier(.77,0,.18,1);}
        .mmenu.open{transform:translateY(0);}
        .mmenu a{font-family:'Bricolage Grotesque',sans-serif;font-size:clamp(22px,7vw,40px);font-weight:800;color:rgba(240,236,255,.7);text-decoration:none;cursor:pointer;transition:color .25s;}
        .mmenu a:hover{color:var(--p);}
        .hero{min-height:100vh;display:flex;flex-direction:column;justify-content:flex-end;padding:0 var(--g) 70px;position:relative;overflow:hidden;}
        .hmesh{position:absolute;inset:0;overflow:hidden;pointer-events:none;}
        .hblob{position:absolute;border-radius:50%;filter:blur(110px);}
        .hgrid{position:absolute;inset:0;background-image:linear-gradient(rgba(255,255,255,.015) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.015) 1px,transparent 1px);background-size:80px 80px;}
        .hi{position:relative;z-index:2;max-width:1240px;width:100%;margin:0 auto;}
        .heyebrow{display:inline-flex;align-items:center;gap:9px;font-size:11px;font-weight:600;letter-spacing:.16em;text-transform:uppercase;color:var(--m);margin-bottom:26px;}
        .heyebrow::before{content:'';width:28px;height:1px;background:var(--v);}
        .htitle{font-size:clamp(42px,8vw,104px);font-weight:800;letter-spacing:-0.025em;line-height:1.0;max-width:960px;margin-bottom:38px;}
        .hbottom{display:grid;grid-template-columns:1fr auto;align-items:flex-end;gap:32px;max-width:960px;}
        .hdesc{font-size:clamp(14px,1.3vw,16px);line-height:1.9;color:var(--m);max-width:390px;font-weight:400;}
        .hbtns{display:flex;gap:10px;flex-wrap:wrap;}
        .hstrip{display:flex;gap:40px;margin-top:52px;padding-top:30px;border-top:1px solid var(--b);}
        .hsn{font-family:'Bricolage Grotesque',sans-serif;font-size:23px;font-weight:800;letter-spacing:-0.02em;margin-bottom:3px;}
        .hsl{font-size:10px;font-weight:600;letter-spacing:.12em;text-transform:uppercase;color:var(--m);}
        .btn-f{background:linear-gradient(135deg,var(--v),var(--p));color:#fff;border:none;padding:13px 30px;font-family:'Outfit',sans-serif;font-weight:700;font-size:12px;letter-spacing:.07em;text-transform:uppercase;cursor:pointer;border-radius:4px;transition:all .35s;position:relative;overflow:hidden;display:inline-flex;align-items:center;gap:8px;}
        .btn-f::before{content:'';position:absolute;inset:0;background:linear-gradient(135deg,var(--p),var(--v));opacity:0;transition:opacity .35s;}
        .btn-f:hover::before{opacity:1;}.btn-f:hover{transform:translateY(-2px);box-shadow:0 10px 32px rgba(147,51,234,.42);}
        .btn-f>*{position:relative;z-index:1;}
        .btn-g{background:transparent;color:var(--w);border:1px solid var(--b2);padding:12px 28px;font-family:'Outfit',sans-serif;font-weight:700;font-size:12px;letter-spacing:.07em;text-transform:uppercase;cursor:pointer;border-radius:4px;transition:all .3s;display:inline-flex;align-items:center;gap:7px;}
        .btn-g:hover{border-color:rgba(240,236,255,.3);background:rgba(240,236,255,.04);}
        .mwrap{border-top:1px solid var(--b);border-bottom:1px solid var(--b);overflow:hidden;padding:12px 0;background:var(--s1);}
        .mtrack{display:flex;white-space:nowrap;animation:mq 22s linear infinite;}.mtrack:hover{animation-play-state:paused;}
        .mitem{font-family:'Bricolage Grotesque',sans-serif;font-size:11px;font-weight:700;letter-spacing:.18em;text-transform:uppercase;color:var(--m);padding:0 28px;display:flex;align-items:center;gap:10px;transition:color .25s;}.mitem:hover{color:var(--p);}
        .mdot{width:3px;height:3px;background:var(--v);border-radius:50%;flex-shrink:0;}
        .sw{max-width:1240px;margin:0 auto;padding:108px var(--g);}
        .slbl{font-size:10px;font-weight:700;letter-spacing:.2em;text-transform:uppercase;color:var(--v);display:flex;align-items:center;gap:9px;margin-bottom:18px;}
        .slbl::before{content:'';width:22px;height:1px;background:var(--v);}
        .stitle{font-size:clamp(30px,4.5vw,56px);font-weight:800;letter-spacing:-0.02em;margin-bottom:48px;max-width:680px;line-height:1.1;}
        .svr{display:grid;grid-template-columns:68px 1fr 1fr auto;align-items:center;gap:26px;padding:26px 0;border-bottom:1px solid var(--b);cursor:pointer;transition:all .3s;position:relative;}
        .svr::before{content:'';position:absolute;left:-16px;right:-16px;top:0;bottom:0;background:rgba(147,51,234,.04);opacity:0;transition:opacity .3s;border-radius:4px;}
        .svr:hover::before{opacity:1;}.svr:first-child{border-top:1px solid var(--b);}
        .snum{font-size:11px;font-weight:700;letter-spacing:.1em;color:var(--v);}
        .sicon{width:38px;height:38px;background:rgba(147,51,234,.1);border:1px solid rgba(147,51,234,.2);border-radius:8px;display:flex;align-items:center;justify-content:center;color:var(--v);transition:all .3s;flex-shrink:0;}
        .svr:hover .sicon{background:rgba(147,51,234,.2);border-color:rgba(232,121,249,.4);color:var(--p);}
        .stw{display:flex;flex-direction:column;gap:3px;}
        .sttl{font-family:'Bricolage Grotesque',sans-serif;font-size:clamp(16px,2vw,24px);font-weight:700;letter-spacing:-0.015em;transition:color .3s;line-height:1.1;}
        .svr:hover .sttl{color:var(--p);}
        .ssub{font-size:11px;color:var(--m);font-weight:600;}
        .sdesc{font-size:13px;color:var(--m);line-height:1.7;font-weight:400;max-width:320px;}
        .stags{display:flex;gap:5px;flex-wrap:wrap;justify-content:flex-end;}
        .stag{font-size:9px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:var(--m);border:1px solid var(--b);padding:3px 8px;border-radius:3px;transition:all .25s;white-space:nowrap;}
        .svr:hover .stag{border-color:rgba(232,121,249,.3);color:var(--p);}
        .sbg{background:var(--s1);border-top:1px solid var(--b);border-bottom:1px solid var(--b);}
        .sgrid{max-width:1240px;margin:0 auto;display:grid;grid-template-columns:repeat(4,1fr);padding:0 var(--g);}
        .scell{padding:50px 0;border-right:1px solid var(--b);text-align:center;}.scell:last-child{border-right:none;}
        .snum2{font-family:'Bricolage Grotesque',sans-serif;font-size:clamp(36px,5vw,58px);font-weight:800;letter-spacing:-0.03em;line-height:1;background:linear-gradient(135deg,var(--w),var(--p));-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;margin-bottom:7px;}
        .slbl2{font-size:10px;font-weight:600;letter-spacing:.13em;text-transform:uppercase;color:var(--m);}
        .wgrid{display:grid;grid-template-columns:1fr 1fr;gap:68px;align-items:start;}
        .fitem{padding:20px 0;border-bottom:1px solid var(--b);display:grid;grid-template-columns:38px 1fr;gap:15px;align-items:start;}.fitem:first-child{border-top:1px solid var(--b);}
        .fico{width:34px;height:34px;background:rgba(147,51,234,.1);border:1px solid rgba(147,51,234,.2);border-radius:8px;display:flex;align-items:center;justify-content:center;color:var(--v);}
        .ftitle{font-family:'Bricolage Grotesque',sans-serif;font-size:14px;font-weight:700;letter-spacing:-0.01em;margin-bottom:3px;}
        .fdesc{font-size:12px;color:var(--m);line-height:1.7;}
        .pcard{background:var(--s2);border:1px solid var(--b);border-radius:10px;overflow:hidden;}
        .pheader{padding:22px 26px 16px;border-bottom:1px solid var(--b);}
        .pstep{display:grid;grid-template-columns:46px 1fr;border-bottom:1px solid var(--b);}.pstep:last-child{border-bottom:none;}
        .psni{padding:17px 0;display:flex;align-items:center;justify-content:center;border-right:1px solid var(--b);color:var(--v);}
        .psc{padding:17px 20px;}
        .pst{font-family:'Bricolage Grotesque',sans-serif;font-weight:700;font-size:13px;letter-spacing:-0.01em;margin-bottom:2px;}
        .psd{font-size:12px;color:var(--m);line-height:1.6;}
        .igrid{display:grid;grid-template-columns:repeat(3,1fr);gap:1px;background:var(--b);border:1px solid var(--b);border-radius:8px;overflow:hidden;}
        .icell{background:var(--s1);padding:22px 20px;transition:background .3s;}.icell:hover{background:var(--s2);}
        .icnt{font-family:'Bricolage Grotesque',sans-serif;font-size:24px;font-weight:800;letter-spacing:-0.02em;color:var(--p);margin-bottom:4px;}
        .ilbl{font-size:12px;color:var(--m);font-weight:500;}
        /* IT PORTFOLIO */
        .it-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:20px;}
        .it-card{background:var(--s1);border:1px solid var(--b);border-radius:10px;overflow:hidden;transition:all .35s;position:relative;}
        .it-card:hover{border-color:rgba(147,51,234,.3);transform:translateY(-4px);box-shadow:0 16px 40px rgba(0,0,0,.35);}
        .it-thumb{height:160px;display:flex;align-items:center;justify-content:center;position:relative;overflow:hidden;}
        .it-body{padding:20px 20px 22px;}
        .it-tag{font-size:9px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;padding:3px 9px;border-radius:3px;display:inline-block;margin-bottom:10px;}
        .it-name{font-family:'Bricolage Grotesque',sans-serif;font-size:16px;font-weight:700;letter-spacing:-0.01em;margin-bottom:6px;}
        .it-desc{font-size:12px;color:var(--m);line-height:1.65;margin-bottom:14px;}
        .it-feats{display:flex;flex-wrap:wrap;gap:5px;margin-bottom:16px;}
        .it-feat{font-size:10px;font-weight:600;color:var(--m);border:1px solid var(--b);padding:3px 8px;border-radius:3px;}
        .it-tech{display:flex;gap:6px;flex-wrap:wrap;}
        .it-tech-tag{font-size:9px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;padding:3px 8px;border-radius:3px;background:rgba(147,51,234,.1);color:rgba(147,51,234,.9);border:1px solid rgba(147,51,234,.2);}
        /* FAQ */
        .faqitem{border-bottom:1px solid var(--b);}.faqitem:first-child{border-top:1px solid var(--b);}
        .faqq{padding:20px 0;display:flex;justify-content:space-between;align-items:center;cursor:pointer;font-family:'Bricolage Grotesque',sans-serif;font-size:clamp(14px,1.3vw,17px);font-weight:700;letter-spacing:-0.01em;user-select:none;transition:color .25s;gap:14px;}
        .faqq:hover{color:var(--p);}
        .faqi{width:26px;height:26px;border:1px solid var(--b);border-radius:50%;display:flex;align-items:center;justify-content:center;color:var(--m);transition:all .3s;flex-shrink:0;}
        .faqitem.open .faqi{background:var(--v);border-color:var(--v);color:#fff;}
        .faqa{overflow:hidden;max-height:0;transition:max-height .4s cubic-bezier(.4,0,.2,1);font-size:14px;color:var(--m);line-height:1.85;}.faqa.open{max-height:180px;}
        .faqa-in{padding-bottom:20px;}
        .cgrid{display:grid;grid-template-columns:1fr 1fr;gap:68px;align-items:start;}
        .citem{display:flex;align-items:flex-start;gap:13px;padding:16px 0;border-bottom:1px solid var(--b);}.citem:last-child{border-bottom:none;}
        .cico{width:34px;height:34px;background:var(--s2);border:1px solid var(--b);border-radius:7px;display:flex;align-items:center;justify-content:center;flex-shrink:0;color:var(--v);}
        .clbl{font-size:9px;font-weight:700;letter-spacing:.16em;text-transform:uppercase;color:var(--m);margin-bottom:3px;}
        .cval{font-size:13px;color:var(--w);font-weight:600;}
        footer{background:var(--s1);border-top:1px solid var(--b);padding:62px var(--g) 30px;}
        .ftop{max-width:1240px;margin:0 auto;display:grid;grid-template-columns:2fr 1fr 1fr 1fr;gap:40px;padding-bottom:46px;border-bottom:1px solid var(--b);margin-bottom:24px;}
        .fct{font-size:10px;font-weight:700;letter-spacing:.18em;text-transform:uppercase;color:var(--m);margin-bottom:14px;}
        .flink{display:block;font-size:13px;color:rgba(240,236,255,.38);text-decoration:none;margin-bottom:8px;cursor:pointer;transition:color .25s;}.flink:hover{color:var(--w);}
        .fbott{max-width:1240px;margin:0 auto;display:flex;justify-content:space-between;align-items:center;font-size:12px;color:rgba(240,236,255,.2);}
        .pslide{transition:transform .3s,box-shadow .3s;}
        @keyframes mq{from{transform:translateX(0)}to{transform:translateX(-50%)}}
        @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-26px)}}
        @keyframes blink{0%,100%{opacity:.7}50%{opacity:1}}
        @keyframes fadeUp{from{opacity:0;transform:translateY(22px)}to{opacity:1;transform:translateY(0)}}
        .fu{animation:fadeUp .85s cubic-bezier(.22,1,.36,1) both;}
        .d0{animation-delay:0s}.d1{animation-delay:.13s}.d2{animation-delay:.26s}.d3{animation-delay:.39s}
        @media(max-width:1024px){.it-grid{grid-template-columns:repeat(2,1fr);}.pslide{min-width:calc(50% - 10px)!important;}}
        @media(max-width:960px){
          .nlinks,.ncta{display:none!important;}.ham{display:flex!important;}
          .hbottom,.wgrid,.cgrid{grid-template-columns:1fr;}
          .sgrid{grid-template-columns:repeat(2,1fr);}
          .ftop{grid-template-columns:1fr 1fr;}
          .igrid{grid-template-columns:repeat(2,1fr);}
          .svr{grid-template-columns:38px 1fr;gap:12px;}.sdesc,.stags{display:none;}
          .pslide{min-width:calc(100% - 0px)!important;}
        }
        @media(max-width:580px){.igrid,.it-grid,.ftop{grid-template-columns:1fr;}.sgrid{grid-template-columns:1fr 1fr;}.hstrip{gap:24px;}}
      `}</style>

            <div className="grain"/>
            <Modal open={modal} onClose={()=>setModal(false)} lang={language}/>

            {/* NAV */}
            <nav>
                <span className="nlogo" onClick={()=>scrollTo("hero")}>
                    <img src="/static/media/logo.png" alt="Logo" width={"100px"}/>
                </span>
                <ul className="nlinks">{t.nav.map((l,i)=><li key={i}><a onClick={()=>scrollTo(navIds[i])}>{l}</a></li>)}</ul>
                <div className="nright">
                    <button className={`lbtn ${language==="uz"?"on":""}`} onClick={()=>setLanguage("uz")}><Globe size={11}/>UZ</button>
                    <button className={`lbtn ${language==="ru"?"on":""}`} onClick={()=>setLanguage("ru")}><Globe size={11}/>RU</button>
                    <button className="ncta" onClick={()=>setModal(true)}>{t.navCta}</button>
                    <button className="ham" onClick={()=>setMenuOpen(!menuOpen)}>
                        <span style={{transform:menuOpen?"rotate(45deg) translate(4px,5px)":"none"}}/>
                        <span style={{opacity:menuOpen?0:1}}/>
                        <span style={{transform:menuOpen?"rotate(-45deg) translate(4px,-5px)":"none"}}/>
                    </button>
                </div>
            </nav>

            {/* MOBILE MENU */}
            <div className={`mmenu ${menuOpen?"open":""}`}>
                {t.nav.map((l,i)=><a key={i} onClick={()=>scrollTo(navIds[i])}>{l}</a>)}
                <div style={{display:"flex",gap:8,marginTop:6}}>
                    <button className={`lbtn ${language==="uz"?"on":""}`} onClick={()=>setLanguage("uz")}><Globe size={11}/>UZ</button>
                    <button className={`lbtn ${language==="ru"?"on":""}`} onClick={()=>setLanguage("ru")}><Globe size={11}/>RU</button>
                </div>
            </div>

            {/* HERO */}
            <section id="hero" className="hero">
                <div className="hmesh">
                    <div className="hblob" style={{width:620,height:620,background:"rgba(147,51,234,.13)",top:"-13%",right:"-7%",animation:"float 14s ease-in-out infinite"}}/>
                    <div className="hblob" style={{width:420,height:420,background:"rgba(232,121,249,.08)",bottom:"5%",left:"-3%",animation:"float 17s ease-in-out infinite reverse"}}/>
                    <div className="hblob" style={{width:250,height:250,background:"rgba(129,140,248,.07)",top:"34%",left:"42%",animation:"float 11s ease-in-out infinite 3s"}}/>
                    <div className="hgrid"/>
                </div>
                <div className="hi">
                    <div className="heyebrow fu d0">{t.eyebrow}</div>
                    <h1 className="htitle fu d1">
                        <span style={{display:"block",color:"var(--w)"}}>{t.h1a}</span>
                        <span className="gtext" style={{display:"block"}}>{t.h1b}</span>
                        <span className="stroke" style={{fontSize:"inherit",display:"block"}}>{t.h1c}</span>
                    </h1>
                    <div className="hbottom fu d2">
                        <p className="hdesc">{t.heroDesc}</p>
                        <div className="hbtns fu d3">
                            <button className="btn-f" onClick={()=>setModal(true)}><span>{t.heroCta1}</span><ArrowRight size={13}/></button>
                            <button className="btn-g" onClick={()=>scrollTo("services")}>{t.heroCta2}</button>
                        </div>
                    </div>
                    <div className="hstrip">
                        {[[h1+"+",t.s1],[h2+"%",t.s2],[h3+"+",t.s3]].map(([n,l])=>(
                            <div key={l}><div className="hsn">{n}</div><div className="hsl">{l}</div></div>
                        ))}
                    </div>
                </div>
            </section>

            {/* MARQUEE */}
            <div className="mwrap">
                <div className="mtrack">
                    {[...t.ticker,...t.ticker,...t.ticker,...t.ticker].map((item,i)=>(
                        <span className="mitem" key={i}><span className="mdot"/>{item}</span>
                    ))}
                </div>
            </div>

            {/* SERVICES */}
            <section id="services">
                <div className="sw">
                    <span className="slbl">{t.svcLbl}</span>
                    <h2 className="stitle">{t.svcT[0]} <span className="gtext">{t.svcT[1]}</span></h2>
                    <ul style={{listStyle:"none"}}>
                        {SVC_DATA[language].map(s=>(
                            <li className="svr" key={s.n}>
                                <span className="snum">{s.n}</span>
                                <div className="sicon"><s.Icon size={17}/></div>
                                <div className="stw"><span className="sttl">{s.title}</span><span className="ssub">{s.full}</span></div>
                                <p className="sdesc">{s.desc}</p>
                                <div className="stags">{s.tags.map(tg=><span className="stag" key={tg}>{tg}</span>)}</div>
                            </li>
                        ))}
                    </ul>
                </div>
            </section>

            {/* STATS */}
            <div className="sbg" ref={statsRef}>
                <div className="sgrid">
                    {[[c1+"+",t.s1],[c2+"%",t.s2],[c3+"+",t.s3],[c4+"+",t.s4]].map(([n,l],i)=>(
                        <div className="scell" key={i}><div className="snum2">{n}</div><div className="slbl2">{l}</div></div>
                    ))}
                </div>
            </div>

            {/* ── IT PORTFOLIO ─────────────────────── */}
            <section id="it-portfolio" style={{background:"var(--s1)"}}>
                <div className="sw">
                    <span className="slbl">{t.itLbl}</span>
                    <h2 className="stitle">{t.itT[0]} <span className="gtext">{t.itT[1]}</span></h2>
                    <p style={{fontSize:14,color:"var(--m)",lineHeight:1.8,maxWidth:560,marginBottom:48,marginTop:-28,fontWeight:400}}>{t.itDesc}</p>
                    <div className="it-grid">
                        {IT_PROJECTS[language].map((p,i)=>(
                            <div className="it-card" key={i}>
                                {/* thumbnail */}
                                <div className="it-thumb" style={{background:`linear-gradient(135deg,rgba(19,12,30,.95),rgba(30,8,46,.9))`}}>
                                    <div style={{position:"absolute",inset:0,background:`radial-gradient(circle at 60% 40%, ${p.color}22 0%, transparent 65%)`}}/>
                                    <div style={{position:"absolute",top:14,left:14,background:`${p.color}18`,border:`1px solid ${p.color}35`,borderRadius:8,padding:"8px 12px",display:"flex",alignItems:"center",gap:7}}>
                                        <p.Icon size={14} color={p.color}/>
                                        <span style={{fontSize:10,fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:p.color}}>{p.label}</span>
                                    </div>
                                    {/* decorative grid */}
                                    <div style={{position:"absolute",inset:0,backgroundImage:`linear-gradient(${p.color}10 1px,transparent 1px),linear-gradient(90deg,${p.color}10 1px,transparent 1px)`,backgroundSize:"30px 30px"}}/>
                                    {/* big icon center */}
                                    <div style={{position:"relative",zIndex:2,width:64,height:64,background:`${p.color}15`,border:`1px solid ${p.color}30`,borderRadius:14,display:"flex",alignItems:"center",justifyContent:"center"}}>
                                        <p.Icon size={28} color={p.color}/>
                                    </div>
                                    {/* tech dots */}
                                    <div style={{position:"absolute",bottom:12,right:14,display:"flex",gap:4}}>
                                        {p.tech.map(tech=>(
                                            <span key={tech} style={{fontSize:9,fontWeight:700,letterSpacing:".07em",background:"rgba(5,3,10,.7)",border:"1px solid rgba(240,236,255,.1)",borderRadius:3,padding:"2px 7px",color:"rgba(240,236,255,.55)"}}>{tech}</span>
                                        ))}
                                    </div>
                                </div>
                                {/* body */}
                                <div className="it-body">
                                    <span className="it-tag" style={{background:`${p.color}18`,color:p.color,border:`1px solid ${p.color}30`}}>{p.cat}</span>
                                    <div className="it-name">{p.title}</div>
                                    <div className="it-desc">{p.desc}</div>
                                    <div className="it-feats">
                                        {p.features.map(f=><span className="it-feat" key={f}>{f}</span>)}
                                    </div>
                                    <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
                                        <a href={p.link} target="_blank" rel="noopener noreferrer"
                                           style={{background:`${p.color}18`,border:`1px solid ${p.color}35`,borderRadius:5,padding:"7px 14px",color:p.color,fontFamily:"'Outfit',sans-serif",fontWeight:700,fontSize:11,letterSpacing:".07em",cursor:"pointer",display:"flex",alignItems:"center",gap:6,transition:"all .25s",whiteSpace:"nowrap",textDecoration:"none"}}
                                           onMouseEnter={e=>{e.currentTarget.style.background=`${p.color}30`;}}
                                           onMouseLeave={e=>{e.currentTarget.style.background=`${p.color}18`;}}>
                                            <ExternalLink size={11}/>{language==="uz"?"Ko'rish":"Открыть"}
                                        </a>
                                        <button onClick={()=>setModal(true)} style={{background:"transparent",border:"1px solid rgba(240,236,255,.1)",borderRadius:5,padding:"7px 14px",color:"var(--m)",fontFamily:"'Outfit',sans-serif",fontWeight:700,fontSize:11,letterSpacing:".07em",cursor:"pointer",display:"flex",alignItems:"center",gap:6,transition:"all .25s",whiteSpace:"nowrap"}}
                                                onMouseEnter={e=>{e.currentTarget.style.borderColor=p.color;e.currentTarget.style.color=p.color;}}
                                                onMouseLeave={e=>{e.currentTarget.style.borderColor="rgba(240,236,255,.1)";e.currentTarget.style.color="var(--m)";}}>
                                            <MessageCircle size={11}/>{language==="uz"?"So'rash":"Запрос"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* IT CTA strip */}
                    <div style={{marginTop:48,padding:"32px 36px",background:"linear-gradient(135deg,rgba(19,12,30,.9),rgba(30,8,46,.8))",border:"1px solid rgba(147,51,234,.2)",borderRadius:10,display:"flex",alignItems:"center",justifyContent:"space-between",gap:24,flexWrap:"wrap"}}>
                        <div>
                            <div style={{fontFamily:"'Bricolage Grotesque',sans-serif",fontSize:20,fontWeight:800,marginBottom:6}}>{language==="uz"?"Loyihangizni muhokama qilaylik":"Обсудим ваш проект"}</div>
                            <p style={{fontSize:13,color:"var(--m)",fontWeight:400}}>{language==="uz"?"Bepul konsultatsiya — 15 daqiqada javob beramiz":"Бесплатная консультация — ответим за 15 минут"}</p>
                        </div>
                        <button className="btn-f" onClick={()=>setModal(true)}><span>{t.heroCta1}</span><ArrowRight size={13}/></button>
                    </div>
                </div>
            </section>

            {/* WHY */}
            <section id="why">
                <div className="sw">
                    <div className="wgrid">
                        <div>
                            <span className="slbl">{t.whyLbl}</span>
                            <h2 style={{fontFamily:"'Bricolage Grotesque',sans-serif",fontSize:"clamp(26px,3.6vw,46px)",fontWeight:800,letterSpacing:"-0.02em",marginBottom:38,lineHeight:1.1}}>
                                {t.whyT[0]} <span className="gtext">{t.whyT[1]}</span>{t.whyT[2]}
                            </h2>
                            {t.whyItems.map(([title,desc],i)=>{
                                const Icon=WHY_ICONS[i];
                                return(
                                    <div className="fitem" key={i}>
                                        <div className="fico"><Icon size={15}/></div>
                                        <div><div className="ftitle">{title}</div><div className="fdesc">{desc}</div></div>
                                    </div>
                                );
                            })}
                        </div>
                        <div>
                            <div className="pcard">
                                <div className="pheader">
                                    <div style={{fontSize:10,fontWeight:700,letterSpacing:".16em",textTransform:"uppercase",color:"var(--m)",marginBottom:5}}>{t.processLbl}</div>
                                    <h3 style={{fontSize:17,fontWeight:700,letterSpacing:"-0.015em"}}>{t.processT}</h3>
                                </div>
                                {t.processSteps.map(([title,desc],i)=>{
                                    const Icon=PROC_ICONS[i];
                                    return(
                                        <div className="pstep" key={i}>
                                            <span className="psni"><Icon size={15}/></span>
                                            <div className="psc"><div className="pst">{title}</div><div className="psd">{desc}</div></div>
                                        </div>
                                    );
                                })}
                                <div style={{padding:"18px 22px"}}>
                                    <button className="btn-f" style={{width:"100%",justifyContent:"center"}} onClick={()=>setModal(true)}>
                                        <span>{t.startNow}</span><ArrowRight size={13}/>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* INDUSTRIES */}
            <section id="industry" style={{background:"var(--s1)"}}>
                <div className="sw">
                    <span className="slbl">{t.indLbl}</span>
                    <h2 className="stitle">{t.indT[0]} <span className="gtext">{t.indT[1]}</span> {t.indT[2]}</h2>
                    <div className="igrid">
                        {INDUSTRIES[language].map(w=>(
                            <div className="icell" key={w.label}>
                                <div className="icnt">{w.count}</div>
                                <div className="ilbl">{w.label}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* PRICING SLIDER */}
            <section id="pricing">
                <div className="sw">
                    <span className="slbl">{t.priceLbl}</span>
                    <h2 className="stitle">{t.priceT[0]} <span className="gtext">{t.priceT[1]}</span></h2>
                    <PricingSlider plans={PLANS[language]} t={t} onModal={()=>setModal(true)} lang={language}/>
                    <p style={{textAlign:"center",marginTop:20,fontSize:13,color:"var(--m)"}}>
                        {t.priceCta} — <span style={{color:"var(--p)",cursor:"pointer",fontWeight:700}} onClick={()=>setModal(true)}>{t.priceCtaLink}</span>
                    </p>
                </div>
            </section>

            {/* FAQ */}
            <section style={{background:"var(--s1)"}}>
                <div className="sw" style={{maxWidth:800}}>
                    <span className="slbl">{t.faqLbl}</span>
                    <h2 className="stitle">{t.faqT[0]} <span className="gtext">{t.faqT[1]}</span></h2>
                    {t.faqs.map(([q,a],i)=>(
                        <div key={i} className={`faqitem ${openFaq===i?"open":""}`}>
                            <div className="faqq" onClick={()=>setOpenFaq(openFaq===i?null:i)}>
                                {q}<span className="faqi">{openFaq===i?<ChevronUp size={12}/>:<ChevronDown size={12}/>}</span>
                            </div>
                            <div className={`faqa ${openFaq===i?"open":""}`}><div className="faqa-in">{a}</div></div>
                        </div>
                    ))}
                </div>
            </section>

            {/* CONTACT */}
            <section id="contact">
                <div className="sw">
                    <div className="cgrid">
                        <div>
                            <span className="slbl">{t.ctaLbl}</span>
                            <h2 style={{fontFamily:"'Bricolage Grotesque',sans-serif",fontSize:"clamp(28px,3.8vw,48px)",fontWeight:800,letterSpacing:"-0.02em",marginBottom:18,lineHeight:1.1}}>
                                {t.ctaT[0]}<br/><span className="gtext">{t.ctaT[1]}</span>
                            </h2>
                            <p style={{fontSize:14,color:"var(--m)",lineHeight:1.85,marginBottom:38,fontWeight:400,maxWidth:340}}>{t.ctaDesc}</p>
                            {[[MapPin,language==="uz"?"Manzil":"Адрес",t.ctaAddress],[Send,"Telegram","@zamonagency_manager"],[AtSign,"Instagram","@zamonagency.uz"]].map(([Icon,lbl,val])=>(
                                <div className="citem" key={lbl}>
                                    <div className="cico"><Icon size={14}/></div>
                                    <div><div className="clbl">{lbl}</div><div className="cval">{val}</div></div>
                                </div>
                            ))}
                            <div style={{marginTop:32}}>
                                <button className="btn-f" onClick={()=>setModal(true)}><MessageCircle size={13}/><span>{t.heroCta1}</span></button>
                            </div>
                        </div>
                        <div style={{background:"var(--s2)",border:"1px solid var(--b)",borderRadius:10,overflow:"hidden"}}>
                            <div style={{height:2,background:"linear-gradient(90deg,var(--v),var(--p))"}}/>
                            <div style={{padding:"28px 26px"}}>
                                <h3 style={{fontSize:17,fontWeight:700,marginBottom:5}}>{t.modalTitle}</h3>
                                <p style={{fontSize:13,color:"var(--m)",marginBottom:22}}>{t.modalDesc}</p>
                                <InlineForm t={t} lang={language}/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* FOOTER */}
            <footer>
                <div className="ftop">
                    <div>
                        <div style={{fontFamily:"'Bricolage Grotesque',sans-serif",fontWeight:800,fontSize:18,letterSpacing:".06em",marginBottom:11}}>
                            <img src="/static/media/logo.png" alt="Logo" width={"100px"}/>
                        </div>
                        <p style={{fontSize:13,color:"var(--m)",lineHeight:1.8,maxWidth:250,marginBottom:18,fontWeight:400}}>{t.footerDesc}</p>
                        <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
                            {["SMM","SEO","Web","Bot"].map(tag=>(
                                <span key={tag} style={{fontSize:9,fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",border:"1px solid var(--b)",borderRadius:3,padding:"3px 8px",color:"var(--m)"}}>{tag}</span>
                            ))}
                        </div>
                    </div>
                    {[
                        [t.footerCol[0],SVC_DATA[language].map(s=>s.title)],
                        [t.footerCol[1],language==="uz"?["Biz haqimizda","Jamoa","Portfolio","Blog","Karyera"]:["О нас","Команда","Портфолио","Блог","Карьера"]],
                        [t.footerCol[2],[t.ctaAddress.split(",")[0],"@zamonagency_manager","@zamonagency.uz"]],
                    ].map(([title,links])=>(
                        <div key={title}>
                            <div className="fct">{title}</div>
                            {links.map(l=><span key={l} className="flink">{l}</span>)}
                        </div>
                    ))}
                </div>
                <div className="fbott">
                    <span>© 2026 Zamon Digital Agency. {t.copyright}</span>
                    <span>SMM · TARGET · IT</span>
                </div>
            </footer>
        </div>
    );
}